// Build-time visibility follows CRA conventions. Backend independently gates capture.
// Default prelaunch: no regulated solicitation or financial-data collection.
const requestedMode = ['disabled', 'prelaunch', 'active'].includes(process.env.REACT_APP_HOME_LOANS_ENABLED)
  ? process.env.REACT_APP_HOME_LOANS_ENABLED : 'prelaunch';
export const HOME_LOANS_MODE = requestedMode === 'active' && process.env.REACT_APP_HOME_LOAN_COMPLIANCE_APPROVED !== 'true' ? 'prelaunch' : requestedMode;
export const HOME_LOANS_VISIBLE = HOME_LOANS_MODE !== 'disabled';
export const HOME_LOANS_TITLE = 'Home Loans & Mortgage Broking | GP Capital';
export const HOME_LOANS_DESCRIPTION = 'Buying, refinancing or investing in Australian property? Explore GP Capital’s structured home-loan process.';
export const homeLoanPurposes = [
  ['purchase', 'Buy a home'], ['refinance', 'Refinance'], ['investment', 'Buy an investment property'],
  ['first_home', 'First home purchase'], ['other', 'Other'],
];
// No public analytics vendor exists. Emit an optional, PII-free first-party hook.
// No UTM retention until the site's tracking/consent policy supports it.
export function homeLoanEvent(name, detail = {}) {
  try { window.dispatchEvent(new CustomEvent(name, { detail })); } catch (_) { /* Never block an enquiry. */ }
}
export function validateHomeLoan(values) {
  const errors = {};
  for (const field of ['firstName', 'lastName']) if (!values[field]?.trim()) errors[field] = 'This field is required.';
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email || '')) errors.email = 'Enter a valid email address.';
  if (!/^(04\d{8}|\+614\d{8})$/.test((values.phone || '').replace(/[ ()-]/g, ''))) errors.phone = 'Enter an Australian mobile number (04… or +614…).';
  if (!homeLoanPurposes.some(([key]) => key === values.loanPurpose)) errors.loanPurpose = 'Choose your enquiry purpose.';
  if (!values.consent) errors.consent = 'Consent is required to submit your enquiry.';
  for (const field of ['estimatedPropertyValue', 'estimatedLoanAmount', 'estimatedDepositOrEquity']) {
    if (values[field] && (!/^\d+$/.test(values[field]) || Number(values[field]) > 100000000)) errors[field] = 'Enter a whole dollar amount between 0 and 100,000,000.';
  }
  return errors;
}
